import React, { createContext, useContext, useState, useCallback } from 'react';

const FilterContext = createContext();

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilter must be used within FilterProvider');
  }
  return context;
};

export const FilterProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    status: '',
    assigneeId: '',
    startDate: '',
    endDate: '',
    showCompleted: false,  // 是否顯示所有已完成任務（預設隱藏非今日完成的任務）
    searchText: '',  // 搜尋任務名稱或敘述
  });

  const updateFilters = useCallback((newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters({
      status: '',
      assigneeId: '',
      startDate: '',
      endDate: '',
      showCompleted: false,
      searchText: '',
    });
  }, []);

  const hasActiveFilters = useCallback(() => {
    return filters.status !== '' || 
           filters.assigneeId !== '' || 
           filters.startDate !== '' || 
           filters.endDate !== '' || 
           filters.searchText !== '';
  }, [filters]);

  const value = {
    filters,
    updateFilters,
    clearFilters,
    hasActiveFilters: hasActiveFilters(),
  };

  return (
    <FilterContext.Provider value={value}>
      {children}
    </FilterContext.Provider>
  );
};

